import { isEmpty } from '~libs.typescript';

import { AdditionalRequirementType } from '../types';

const ADDITIONAL_REQUIREMENT_TYPES: AdditionalRequirementType[] = ['CITO', 'FOR_YEAR', 'SUBSTITUTE_FORBIDDEN'];
const MOBILE_ADDITIONAL_REQURIEMENT_TYPES: AdditionalRequirementType[] = ['FOR_YEAR', 'SUBSTITUTE_FORBIDDEN'];

export const getAdditionalRequirementsTypes = (): AdditionalRequirementType[] => {
   return ADDITIONAL_REQUIREMENT_TYPES;
};

export const getMobileAdditionalRequirementsTypes = (): AdditionalRequirementType[] => {
   return MOBILE_ADDITIONAL_REQURIEMENT_TYPES;
};

type SelectAdditionalRequirementsTypesParameters = {
   cito: boolean;
   issuedForYear: boolean;
   substituteForbidden: boolean;
};

export const selectAdditionalRequirementsTypes = (
   parameters: SelectAdditionalRequirementsTypesParameters
): AdditionalRequirementType[] => {
   const requirements: AdditionalRequirementType[] = [];

   if (parameters.cito) {
      requirements.push('CITO');
   }

   if (parameters.issuedForYear) {
      requirements.push('FOR_YEAR');
   }

   if (parameters.substituteForbidden) {
      requirements.push('SUBSTITUTE_FORBIDDEN');
   }

   return requirements;
};

export const formatAdditionalRequirements = (
   additionalRequirementTypes: AdditionalRequirementType[],
   formatter: (type: AdditionalRequirementType) => string
): string | null => {
   if (isEmpty(additionalRequirementTypes)) {
      return null;
   }

   return additionalRequirementTypes.map(formatter).join(', ');
};
